<script lang="ts">
  import { Label } from "$lib/components/ui/label";
  import { t } from "$lib/i18n";

  let { description = $bindable(), isReadonly = false }: { description: string, isReadonly?: boolean } = $props();
</script>

<div class="grid grid-cols-4 items-start gap-4">
  <Label for="description" class="pt-2">{$t('fields.description')}</Label>
  <textarea
    readonly={isReadonly}
    id="description"
    bind:value={description}
    placeholder={$t('fields.descriptionPlaceholder')}
    rows={3}
    class="col-span-3 border-input bg-background placeholder:text-muted-foreground shadow-xs min-w-0 rounded-md border px-3 py-1 text-base outline-none resize-none overflow-y-auto transition-[color,box-shadow] focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm"
  ></textarea>
</div>
